module.exports = __webpack_public_path__ + "img/likert.7bf776a7.png";